<div class="user-card inner-shadow" [routerLink]="redirectUrl">
    <div class="details">
        <div class="title text-left">{{data.fullname}}</div>
        <div class="detail">
            <ng-container *ngIf="data.roles[0]; let role">
                <div class="desc">{{(role === 'SuperAdmin' ? 'Maintainer' : role) | translate}}</div>
            </ng-container>
            <div class="desc">{{data.email}}</div>
            <div class="date">{{ 'Last Seen' | translate }}: {{lastSeen | date:'short'}}</div>
        </div>
    </div>
    <div class="avatar" [style.backgroundImage]="background_image"></div>
</div>